import "../../Styling/Quality.css";
import frontrunner from "../../Assets/Images/frontrunner.mov"
import automation from "../../Assets/Images/automation.mov"

const Quality = () => {
  return (
    <div className="quality-wrapper">
      <h2 className="quality-title">
        Explore entire user journeys with flows.
      </h2>
      <div className="quality-content-wrapper">
      <figure className="quality-figure">
          <div className="quality-figure-item-wrapper">
            <div className="quality-figure-video-wrapper">
              <video
                autoPlay
                muted
                loop
                disablePictureInPicture
                disableRemotePlayback
                playsInline
                className="quality-figure-video-first"
              >
                <source
                  type="video/mp4"
                  src={frontrunner}
                ></source>
              </video>
            </div>
          </div>
          <figcaption className="quality-figure-caption-wrapper">
            <p className="quality-figure-caption-title">Videos</p>
            <p className="quality-figure-caption-details">
              Experience flows the way they were meant to be experienced,
              complete with transitions, micro-interactions, and animations.
            </p>
          </figcaption>
        </figure>
        <figure className="quality-figure">
          <div className="quality-figure-item-wrapper">
            <div className="quality-figure-video-wrapper">
              <video
                autoPlay
                muted
                loop
                disablePictureInPicture
                disableRemotePlayback
                playsInline
                className="quality-figure-video"
              >
                <source
                  type="video/mp4"
                  src={automation}
                ></source>
              </video>
            </div>
          </div>
          <figcaption className="quality-figure-caption-wrapper">
            <p className="quality-figure-caption-title">Prototype mode</p>
            <p className="quality-figure-caption-details">
            Experience flows the way they were meant to be experienced, complete with transitions, micro-interactions, and animations.
            </p>
          </figcaption>
        </figure>
      </div>
    </div>
  );
};

export default Quality;
